<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'asset-fund-investment'" [commentSlug]="'asset-gp-valuation'">
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">GP Valuation</mat-card-title>
        @if (fundCurrencyIso$ | async; as fundCurrencyIso) {
            <valumize-currency-badge
                kind="FUND"
                [iso]="fundCurrencyIso"
                tooltip="All amounts on this card are in the fund's reporting currency">
            </valumize-currency-badge>
        }
    </mat-card-header>
    @if ((generalPartnerValuation$ | async); as gpValuation) {
        <mat-card-subtitle>
            @if (gpValuation.status === 'ERROR') {
                <valumize-info-panel [appearance]="'ERROR'" [message]="gpValuation.errorMessage"></valumize-info-panel>
            }
            @if (gpValuation.status === 'SAVED') {
                <valumize-info-panel [appearance]="'SAVED'" [message]="'GP Valuation successfully saved'"></valumize-info-panel>
            }
            @if (gpValuation.status === 'LOADING') {
                <mat-progress-spinner></mat-progress-spinner>
            }
        </mat-card-subtitle>
        @if (!!gpValuation.data.id) {
            <mat-card-content class="detail-card-content">
                <div class="key-value-pair-section">
                    <div class="key-value-pair-column">
                        <valumize-mergeable-select-code
                            [label]="'GP Indication'"
                            [isEditable]=isEditable
                            [isDataset]=isDataset
                            [codeTable]=codeTableGpIndication
                            [code]=gpValuation.data.gpIndication
                            [baselineCode]=baselineFundInvestment.gpIndication
                            [control]=gpValuationForm.controls.gpIndication>
                        </valumize-mergeable-select-code>
                        <div class="key-value-pair">
                            <div class="key-value-item">
                                Unrealized TVPI
                            </div>
                            <div class="key-value-item">
                                {{ gpValuation.data.unrealizedTVPI | traceableFormat }}
                            </div>
                        </div>
                        <div class="key-value-pair">
                            <div class="key-value-item">
                                Realized TVPI
                            </div>
                            <div class="key-value-item">
                                {{ gpValuation.data.realizedTVPI | traceableFormat }}
                            </div>
                        </div>
                    </div>
                    <div class="key-value-pair-column">
                        <div class="key-value-pair">
                            <div class="key-value-item">
                                Total TVPI
                            </div>
                            <div class="key-value-item">
                                {{ gpValuation.data.totalTVPI | traceableFormat }}
                            </div>
                        </div>
                        <div class="key-value-pair">
                            <div class="key-value-item">
                                Real. % of Invest.
                            </div>
                            <div class="key-value-item">
                                {{ gpValuation.data.realizedPercentageOfInvestment | traceableFormat }}
                            </div>
                        </div>
                    </div>
                    <div class="key-value-pair-column">
                        <div class="key-value-pair">
                            <div class="key-value-item">
                                Total IRR
                            </div>
                            <div class="key-value-item">
                                {{ gpValuation.data.totalIRR | traceableFormat }}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div style="width: 48%">
                        @if (generalPartnerValuationTableData$ | async; as dataSource) {
                            <form [formGroup]="gpValuationForm">
                                <table mat-table [dataSource]="dataSource">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell class="{{styleRequiredFormFieldWithAsterisk(element.type)}}" *matCellDef="let element">{{ element.name }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="fundLevel">
                                        <th mat-header-cell *matHeaderCellDef>Fund Level</th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                            @if (!isEditable) {
                                                <div class="fund-level-cell">
                                                    @if (element.baselineFundLevelValue && formControlIsEditable(element.type)) {
                                                        <mat-chip
                                                            class="chip"
                                                            [ngClass]="getBaselineChipColorReadonly(
                                                                element.baselineFundLevelValue,
                                                                element.fundLevelValue
                                                            )">
                                                            {{ element.baselineFundLevelValue | traceableFormat }}
                                                        </mat-chip>
                                                    }
                                                    <span>{{ element.fundLevelValue | traceableFormat }}</span>
                                                </div>
                                            } @else if (isEditable && formControlIsEditable(element.type)) {
                                                <div class="fund-level-cell">
                                                    @if (element.baselineFundLevelValue) {
                                                        <mat-chip-option
                                                            class="chip"
                                                            (click)="overwriteFundLevelValue(element.type, element.baselineFundLevelValue)"
                                                            [ngClass]="getBaselineChipColor(
                                                                getControl(element.type),
                                                                element.baselineFundLevelValue,
                                                                element.fundLevelValue
                                                            )">
                                                            {{ element.baselineFundLevelValue | traceableFormat }}
                                                        </mat-chip-option>
                                                    }
                                                    <input
                                                        matInput
                                                        type="number"
                                                        class="input-number-narrow"
                                                        formControlName="{{element.type}}"
                                                        [id]="element.type"
                                                        (change)="calc(element.type)">
                                                </div>
                                            } @else if (isEditable && !formControlIsEditable(element.type)) {
                                                <span>{{ element.fundLevelValue | traceableFormat }}</span>
                                            }
                                        </td>
                                    </ng-container>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="{{styleRowImportant(row)}}"></tr>
                                </table>
                            </form>
                        }
                    </div>
                    <div style="width: 48%;">
                        @if (generalPartnerCapexTableData$ | async; as capexDataSource) {
                            <form [formGroup]="gpValuationForm">
                                <table mat-table [dataSource]="capexDataSource">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="fundLevel">
                                        <th mat-header-cell *matHeaderCellDef>Fund Level</th>
                                        <td mat-cell *matCellDef="let element">
                                            @if (!isEditable) {
                                                <div class="fund-level-cell">
                                                    @if (element.baselineFundLevelValue && formControlIsEditable(element.type)) {
                                                        <mat-chip
                                                            class="chip"
                                                            [ngClass]="getBaselineChipColorReadonly(
                                                              element.baselineFundLevelValue,
                                                              element.fundLevelValue
                                                            )">
                                                            {{ element.baselineFundLevelValue | traceableFormat }}
                                                        </mat-chip>
                                                    }
                                                    <span>{{ element.fundLevelValue | traceableFormat }}</span>
                                                </div>
                                            } @else if (isEditable && formControlIsEditable(element.type)) {
                                                <div class="fund-level-cell">
                                                    @if (element.baselineFundLevelValue) {
                                                        <mat-chip-option
                                                            class="chip"
                                                            (click)="overwriteFundLevelValue(element.type, element.baselineFundLevelValue)"
                                                            [ngClass]="getBaselineChipColor(
                                                               getControl(element.type),
                                                               element.baselineFundLevelValue,
                                                               element.fundLevelValue
                                                            )">
                                                            {{ element.baselineFundLevelValue | traceableFormat }}
                                                        </mat-chip-option>
                                                    }
                                                    <input
                                                        matInput
                                                        class="input-number-narrow"
                                                        type="number"
                                                        formControlName="{{element.type}}"
                                                        [id]="element.type"
                                                        (change)="calc(element.type)">
                                                </div>
                                            } @else if (isEditable && !formControlIsEditable(element.type)) {
                                                <span>{{ element.fundLevelValue | traceableFormat }}</span>
                                            }
                                        </td>
                                    </ng-container>
                                    <tr mat-row *matRowDef="let row; columns: ['name', 'fundLevel'];"></tr>
                                </table>
                            </form>
                        }
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="detail-card-actions">
                <div class="last-modified" data-test="modification-date">Last modified: {{ gpValuation.data.realizedTVPI.modDate | timestamp }}</div>
                @if (!isEditable) {
                    <button (click)="editMode()"
                            [disabled]="(isEditDisabled$ | async)!"
                            color="primary"
                            data-test="edit-button"
                            mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="save()"
                            [disabled]="gpValuationForm.invalid"
                            color="primary"
                            data-test="save-button"
                            mat-icon-button>
                        <mat-icon>save</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="cancel()"
                            color="primary"
                            data-test="cancel-button"
                            mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
                <valumize-card-comments-button [commentScope]="'asset-fund-investment'" [commentSlug]="'asset-gp-valuation'"></valumize-card-comments-button>
            </mat-card-actions>
        } @else {
            <mat-card-content class="detail-card-content" style="color: grey">
                Please select a fund report first!
            </mat-card-content>
        }
    }
</mat-card>
